import React from "react";
import { Link } from "react-router-dom";
import { Card, Row, Col } from "react-bootstrap";
import Spinner from "../generics/Spinner";

const StatCard = ({ title, value, icon, color = "#0d6efd", alert = false }) => (
  <Card className="mb-3">
    <Card.Body className="p-3">
      <div className="d-flex align-items-center">
        <div
          className="me-3 d-flex align-items-center justify-content-center"
          style={{
            width: "48px",
            height: "48px",
            borderRadius: "4px",
            backgroundColor: color,
            opacity: 0.9,
          }}
        >
          <i className={`fa ${icon} fa-lg`} style={{ color: "#fff" }}></i>
        </div>
        <div>
          <h4 className="mb-0" style={{ fontWeight: "600" }}>
            {value}
            {alert && value > 0 && (
              <i className="fa fa-exclamation-triangle ms-2 text-danger" style={{ fontSize: "0.6em" }}></i>
            )}
          </h4>
          <small className="text-muted">{title}</small>
        </div>
      </div>
    </Card.Body>
  </Card>
);

const ProviderDashboard = ({
  dashboard,
  loading,
  error,
  onRefresh,
}) => {
  if (loading && !dashboard) {
    return <Spinner />;
  }

  return (
    <div className="provider-dashboard">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h5 className="mb-0">
            <i className="fa fa-dashboard me-2"></i>
            Welcome{dashboard?.provider_name ? `, ${dashboard.provider_name}` : ""}
          </h5>
        </div>
        <button className="btn btn-secondary btn-sm" onClick={onRefresh}>
          <i className="fa fa-refresh me-1"></i> Refresh
        </button>
      </div>

      {error && (
        <div className="alert alert-danger mb-3">
          <i className="fa fa-exclamation-circle me-2"></i>
          {error.message || "Error loading dashboard"}
        </div>
      )}

      <Row>
        <Col lg={4} md={6}>
          <StatCard
            title="Tasks Due Today"
            value={dashboard?.tasks_due_today || 0}
            icon="fa-calendar-check-o"
            color="#0d6efd"
          />
        </Col>
        <Col lg={4} md={6}>
          <StatCard
            title="Overdue Tasks"
            value={dashboard?.overdue_tasks || 0}
            icon="fa-exclamation-triangle"
            color="#ff5454"
            alert
          />
        </Col>
        <Col lg={4} md={6}>
          <StatCard
            title="In Progress"
            value={dashboard?.in_progress_tasks || 0}
            icon="fa-spinner"
            color="#ffc107"
          />
        </Col>
        <Col lg={6} md={6}>
          <StatCard
            title="Pending Tasks"
            value={dashboard?.pending_tasks || 0}
            icon="fa-clock-o"
            color="#0dcaf0"
          />
        </Col>
        <Col lg={6} md={6}>
          <StatCard
            title="Completed This Week"
            value={dashboard?.completed_this_week || 0}
            icon="fa-check-circle"
            color="#198754"
          />
        </Col>
      </Row>

      <Card className="mb-3">
        <Card.Header className="card-header-grey">
          <strong><i className="fa fa-bolt me-2"></i>Quick Actions</strong>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md={4} className="mb-2 mb-md-0">
              <Link to="/provider-portal/tasks" className="btn btn-primary w-100">
                <i className="fa fa-tasks me-2"></i>
                View All Tasks
              </Link>
            </Col>
            <Col md={4} className="mb-2 mb-md-0">
              <Link to="/provider-portal/tasks?status=PENDING" className="btn btn-outline-primary w-100">
                <i className="fa fa-clock-o me-2"></i>
                Pending Tasks
              </Link>
            </Col>
            <Col md={4}>
              <Link to="/provider-portal/tasks?status=IN_PROGRESS" className="btn btn-outline-primary w-100">
                <i className="fa fa-spinner me-2"></i>
                In Progress
              </Link>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {dashboard?.overdue_tasks > 0 && (
        <Card className="border-danger">
          <Card.Body className="d-flex align-items-center justify-content-between py-3">
            <div className="d-flex align-items-center">
              <i className="fa fa-exclamation-triangle fa-2x me-3" style={{ color: "#ff5454" }}></i>
              <div>
                <strong style={{ color: "#ff5454" }}>
                  You have {dashboard.overdue_tasks} overdue task{dashboard.overdue_tasks !== 1 ? "s" : ""}
                </strong>
                <p className="text-muted mb-0 small">Please complete these as soon as possible</p>
              </div>
            </div>
            <Link to="/provider-portal/tasks?status=OVERDUE" className="btn btn-danger btn-sm">
              View Overdue
            </Link>
          </Card.Body>
        </Card>
      )}
    </div>
  );
};

export default ProviderDashboard;
